import { Topic, useAuthStateStore, AnalyticsEventEmitter, getUserInfoFromIdToken, } from '@annunciate/core';
import { CountFlushPolicy, createClient, TimerFlushPolicy, } from '@segment/analytics-react-native';
import { DEFAULT_TOPICS } from './consts';
import { ScreenEnrichmentPlugin, WebEnrichmentPlugin, } from './plugins';
import { useSegmentAnalyticsStore } from './store';
export const SegmentAnalyticsService = ({ appVersion, appName = '', topics = DEFAULT_TOPICS, plugins: customPlugins, additionalPlugins = [], ...segmentClientOptions }) => {
    if (!segmentClientOptions.proxy
        || segmentClientOptions.proxy.startsWith('/')
        || !segmentClientOptions.writeKey) {
        console.warn(`A segment-analytics was configured, with invalid values`, {
            proxy: segmentClientOptions.proxy,
            cdnProxy: segmentClientOptions.cdnProxy,
            writeKey: segmentClientOptions.writeKey,
        });
        return;
    }
    const flushPolicies = [
        new CountFlushPolicy(20),
        new TimerFlushPolicy(30 * 1000),
    ];
    const client = createClient({
        flushPolicies,
        ...segmentClientOptions,
    });
    const plugins = customPlugins || [
        new WebEnrichmentPlugin({ appVersion, appName }),
        new ScreenEnrichmentPlugin(),
    ];
    for (const plugin of plugins) {
        client.add({ plugin });
    }
    for (const plugin of additionalPlugins) {
        client.add({ plugin });
    }
    useAuthStateStore.subscribe((state, prev) => {
        if (state.uuid === prev.uuid) {
            return;
        }
        if (state.uuid) {
            const userInfo = getUserInfoFromIdToken(state.jwt);
            client.identify(state.uuid, userInfo);
        }
        else {
            client.reset();
        }
    });
    AnalyticsEventEmitter.on(Topic._IDENTIFY, async (uuid) => {
        await client.identify(uuid);
    });
    if (topics.includes(Topic.APP_SCREEN_VIEWED)) {
        AnalyticsEventEmitter.on(Topic.APP_SCREEN_VIEWED, async ({ payload }) => {
            const name = payload.path || payload.title;
            await client.screen(name, { userId: payload.userId });
        });
    }
    const immediateFlushTopics = new Set([
        Topic.PURCHASE_COMPLETED,
    ]);
    const onTrack = async ({ topic, payload }) => {
        await client.track(topic, payload);
        if (immediateFlushTopics.has(topic)) {
            await client.flush();
        }
    };
    for (const topic of topics) {
        if (topic === Topic.APP_SCREEN_VIEWED) {
            continue;
        }
        AnalyticsEventEmitter.on(topic, onTrack);
    }
    useSegmentAnalyticsStore.setState({ client });
};
//# sourceMappingURL=SegmentAnalyticsService.js.map